export var DISALLOWED_CHARACTERS_PATTERN = /^['&;"]|['&;"]$|[<>]/;
export var STATE = 'state';
export var ADDRESS_FIELDS_TO_VALIDATE = ['line1', 'line2', 'city'];